{
  "name": "sugar-suite",
  "private": true,
  "version": "1.3.8",
  "type": "module",
  "packageManager": "npm@11.19.1",
  "scripts": {
    "build": "vite build",
    "quick": "vite build && vite preview --port 9000",
    "preview": "concurrently \"vite build --watch\" \"vite preview --port 9000\"",
    "test": "jest",
    "test:watch": "jest --watch",
    "test:coverage": "jest --coverage"
  },
  "dependencies": {
    "@opentelemetry/api": "^1.10.0",
    "@opentelemetry/browser-instrumentation": "^0.9.0",
    "@opentelemetry/exporter-logs-otlp-http": "^0.300.0",
    "@opentelemetry/instrumentation": "^0.300.0",
    "@opentelemetry/resources": "^3.0.0",
    "@opentelemetry/sdk-logs": "^3.0.0",
    "@opentelemetry/semantic-conventions": "^1.43.0"
  },
  "devDependencies": {
    "vite": "^8.3.5",
    "sass": "^1.106.1",
    "postcss": "^8.5.32",
    "autoprefixer": "^10.6.2",
    "cssnano": "^9.9.0",
    "esbuild": "^0.28.2",
    "terser": "^5.51.2",
    "vite-plugin-compression2": "^2.5.4",
    "glob": "^13.0.6",
    "concurrently": "^10.0.6",
    "jquery": "^4.0.0",
    "jest": "^30.5.2",
    "jest-environment-jsdom": "^30.5.2",
    "@testing-library/dom": "^10.4.2",
    "@testing-library/jest-dom": "^7.0.1"
  }
}
